import styles from './WorkExperienceHeader.module.css';
import { SVG } from 'com-ashatou-ui/dist';

function WorkExperienceHeader() {
    return (
        <div className={styles['work-experience-header']}>
            <img
                src={SVG.General.engineer}
                alt='Engineer icon'
                className={`${styles['work-experience-header-icon']}`}
            />
            <h1 className={styles['work-experience-title']}>
                With nearly two decades of engineering experience, I have contributed to the success
                of more than ten organizations. My roles have encompassed software development,
                design, testing, product management, and engineering management. I excel in
                collaborative cross-functional teams that prioritize delivering value and maximizing
                my diverse experience, knowledge, and skills.
            </h1>
        </div>
    );
}

export default WorkExperienceHeader;
